// src/stone/icons/Grid.tsx
import { jsx } from "react/jsx-runtime";
var Grid = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        stroke: "currentcolor",
        d: "M10 3H3v7h7zM21 3h-7v7h7zM21 14h-7v7h7zM10 14H3v7h7z"
      }
    )
  }
);
var Grid_default = Grid;

export {
  Grid,
  Grid_default
};
